export default __webpack_public_path__ + "static/header-hero-aeec233ab62e2bb256940cd824cc92f4.png";